<template>
  <v-dialog v-model="dialog" :overlay="false" scrollable max-width="600">
    <v-card tile flat>
      <v-toolbar dark color="primary">
        <v-app-bar-nav-icon><v-icon>fas fa-ad</v-icon></v-app-bar-nav-icon>
        <v-toolbar-title>Create a new advert</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="closeDialog" dark>
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text style="height: 526px">
        <v-form lazy-validation>
          <v-container fluid grid-list-md>
            <v-layout wrap>
              <v-flex>
                <v-layout wrap>
                  <v-flex xs10>
                    <v-text-field label="Advert name" v-model="advert.name" required></v-text-field>
                  </v-flex>
                  <v-flex xs10>
                    <v-text-field label="Target URL" v-model="advert.url" required></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs6>
                    <v-label>Advert Image <small>&mdash; should be 656x656</small></v-label>
                    <image-upload
                      :url.sync="advert.image_url"
                      :path="'partner-images'"
                      :width="656"
                      :height="656"
                    ></image-upload>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="accent" @click.native="createAdvert(advert)">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ImageUpload from '../Partners/ImageUpload';
import { mapActions } from 'vuex';
export default {
  name: 'NewAdvertDialog',
  components: { ImageUpload },
  props: ['show'],
  data: () => ({
    advert: {
      name: null,
      image_url: null,
      url: null
    }
  }),
  computed: {
    dialog: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      }
    }
  },
  methods: {
    ...mapActions(['createAdvert']),
    closeDialog() {
      this.dialog = false;
    }
  }
};
</script>

<style scoped></style>
